/* sdk内部数据缓存 */
const storage = {
    userInfo: {},
    locationInfo: { lat: 0, lng: 0 },
    riskParams: {},
    openId: '',
    webxPageConfig: {},
    webxShareConfig: {},
    webxNineChapterParams: {}
};
/* seal缓存对象 禁止扩展/删除该对象 */
Object.seal(storage);
export { storage, };
